import type { Schema } from '@app/backend/data/resource'
import type { DataClient } from '@/lib/amplify'
import { requireData } from './amplifyError'

export type OperationsReport = Schema['OperationsReport']['type']
export type SectionStatus = 'ok' | 'absent' | 'unknown'

/**
 * What the account says about this environment right now — alarms, dead letters, the uptime check,
 * spend and deploys. One read: the Lambda behind it reports each section as checked, absent or
 * unreadable, so a section that failed comes back as data rather than failing the whole page.
 */
export async function getOperationsReport(client: DataClient): Promise<OperationsReport> {
    return requireData(await client.queries.operations(), 'operations')
}
